// extracted by mini-css-extract-plugin
module.exports = {"blockQuote":"image-module--blockQuote--2IKCp","portableText":"image-module--portableText--WX5ij","layout__wrapper":"image-module--layout__wrapper--19Hsa"};